import { CommandName, getFragment, } from "../../../../src/ipm/background";
import * as logger from "~/utilities/background";
import { CreationMethod, defaultCreationMethod, defaultPriority, } from "./new-tab.types";
function getParamDefinitionList() {
    const { isEmptyOrPositiveNumber, isSafeUrl, isValidLicenseStateList } = getFragment();
    return [
        {
            name: "url",
            validate: isSafeUrl,
        },
        {
            name: "license_state_list",
            validate: isValidLicenseStateList,
        },
        {
            name: "method",
            validate: (param) => typeof param === "undefined" ||
                (typeof param === "string" &&
                    Object.values(CreationMethod)
                        .map((method) => String(method))
                        .includes(param)),
        },
        {
            name: "priority",
            validate: isEmptyOrPositiveNumber,
        },
    ];
}
function isNewTabCommand(command) {
    const validationErrors = getFragment().validateParams(command, getParamDefinitionList());
    if (validationErrors.length === 0) {
        return true;
    }
    logger.error("[new-tab]: Invalid parameters received:", validationErrors.join(" "));
    return false;
}
export function isNewTabBehavior(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "target" in candidate &&
        "method" in candidate &&
        "priority" in candidate);
}
function getBehavior(command) {
    if (!isNewTabCommand(command)) {
        return null;
    }
    const method = typeof command.method === "undefined" ? defaultCreationMethod : CreationMethod[command.method];
    return {
        target: command.url,
        licenseStateList: command.license_state_list || getFragment().defaultLicenseState,
        method,
        priority: typeof command.priority === "number" ? command.priority : defaultPriority,
    };
}
function getContent() {
    return {};
}
export function setNewTabCommandHandler(handler, clearCommands, onCommandsProcessed) {
    getFragment().setCommandActor(CommandName.createTab, {
        clearCommands,
        getBehavior,
        getContent,
        handleCommand: handler,
        isValidCommand: isNewTabCommand,
        onCommandsProcessed,
    });
}
